import React, { useState, useEffect } from 'react';
import { UserDetailsForm } from './User DetailsForm';
import { User, Mail, Phone, Calendar, Award } from 'lucide-react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export const ProfilePage = ({ userPhone }) => {
  const [userDetails, setUserDetails] = useState({
    name: '',
    email: 'Not provided',
    phone: userPhone,
    tier: 'Bronze',
    memberSince: '2024'
  });

  useEffect(() => {
    const fetchUser = async () => {
      if (!userPhone) return;

      const userRef = doc(db, 'users', userPhone);
      const snap = await getDoc(userRef);

      if (snap.exists()) {
        const data = snap.data();
        setUserDetails({
          name: data.name || '',
          email: data.email || 'Not provided',
          phone: data.phone || userPhone,
          tier: data.tier || 'Bronze',
          memberSince: data.memberSince || '2024'
        });
      }
    };

    fetchUser();
  }, [userPhone]);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Profile Settings</h1>
        <p className="text-gray-600">Manage your account information and preferences</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Profile Summary */}
        <div className="lg:col-span-1">
          <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-8">
            <div className="text-center mb-6">
              <div className="w-24 h-24 bg-gradient-to-r from-yellow-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <User size={40} className="text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-800">{userDetails.name || 'User'}</h3>
              <p className="text-gray-600">Loyalty Member</p>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3 text-gray-600">
                <Phone size={18} />
                <span>{userDetails.phone}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-600">
                <Mail size={18} />
                <span>{userDetails.email}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-600">
                <Calendar size={18} />
                <span>Member since {userDetails.memberSince}</span>
              </div>
              <div className="flex items-center gap-3 text-gray-600">
                <Award size={18} />
                <span className="text-yellow-600 font-semibold">{userDetails.tier} Tier</span>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Form */}
        <div className="lg:col-span-2">
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Update Your Information</h2>
            <UserDetailsForm phoneNumber={userPhone} />
          </div>
        </div>
      </div>
    </div>
  );
};
